<template>
<!-- 押金 -->
<div class="menuBody" >
     <CashPledgeTree @CashPledgeTree="CashPledgeTree" />
        <CashPledgeDialog :param="diaLogData" ref="CashPledgeDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
             <div class="PageTabs">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="押金已收列表" name="first">押金已收列表</el-tab-pane>
                <el-tab-pane label="押金退款列表" name="second">押金退款列表</el-tab-pane>
              </el-tabs>
            </div>
              <!-- <div style="float:left;">
                <el-button type="primary" size="small" plain   @click="CashPledge()">押金收费</el-button>
            </div> -->

            <el-table  :data="tableData" tooltip-effect="light"  v-loading="loading"  style="overflow-y: scroll;float:right;margin-top:30px" 
    row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="invoiceDm" label="票据簿编号"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceHm" label="票据号码"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceObject" label="收费项目"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="crmName" label="付款人"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="address" label="房间名称"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="money" label="金额"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeitemCode" label="科目代号"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payMethod" label="收费方式"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjSkrq" label="收款日期"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payee" label="收款人"  ></el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import CashPledgeDialog from "../common/CashPledgeDialog";
import CashPledgeTree from "../common/CashPledgeTree.vue";

export default {
  name: "CashPledgeDel",
  components: {CashPledgeDialog,CashPledgeTree},
  data() {
    return {
 activeName:"second",
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillDateVal:"",
         props: { multiple: true },
      tableData: [],
      options: [],
        value: '',
        ChargeItemList:[],
        ChargeItemvalue:"",
        HouseNatureList:[],
        HouseNaturevalue:"",



      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      taxRateval:"",
    }
  },
       watch: {
    //   // 监听路由变化
     "$route.path": function(newVal, oldVal) {
       if(`${newVal}` == "/charge/bills/depositIndex"){
       this.activeName = "first"
       }else if(`${newVal}` == "/charge/bills/CashPledgeDel"){
        this.activeName = "second"
       }
     }
  },
  methods: {
            handleSizeChange(val) {
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
                 handleClick(tab, event) {
        if(this.activeName == "first"){
          this.activeName = "first"
          this.$router.push({name: 'CashPledge'})
        }else if(this.activeName == "second"){
          this.activeName = "second"
          this.$router.push({name: 'CashPledgeDel'})
        }
      },
        CashPledgeTree(data){
        if(data.orgId != null){
          this.projectId = data.id
        }else if(data.customerId){
           this.customerId = data.customerId
        this.ShareList()
        }
      this.AllData = data
    },
      CashPledge(){
      this.$refs.CashPledgeDialog.title = "押金收费信息";
      this.$refs.CashPledgeDialog.dialogVisible = true; 
      this.$refs.CashPledgeDialog.isType = "0"
            let obj = {
                "BillType":"票据类型",
                "NoteBook":"票据簿",
                "NoteNum":"票据号",
                "payer":"付款人",
                "DutyNum":"税号",
                "Account":"账号",
                "Site":"地址",
                "total":"合计",
                "income":"合计收入",
                "amount":"合计税额",
                "remarks":"备注",
                "receipt":"收款日期",
                "mode":"收款方式",
                "hint":"提示用户电子发票有附加信息：",
                "invoice":"开票人",
                "proceeds":"收款人",
                "invoiceDate":"开票日期"

          }
          let row ={}
        row.obj = obj
 
         this.$refs.CashPledgeDialog.formLabelAlign= row;
      },
      HouseNature(){
          // 房间类型
      },
      ChargeItemL(val){
          // console.log(val)
      },
      BillDate(){
          // console.log(this.BillDateVal)
      },
      getSummaries(parms){
          // console.log(parms)
      },
    Details(){
      // 查看详情
    },
      BillNucleu(val){
          // console.log(val)
          this.taxRateval = val
      },
    getMsgFormSon(data){
        // console.log(data)
      this.AllData = data
    },
    ShareList(){
          let PageSize = {
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
            "isDeposit":"2", // 退款状态    2 退款  0 未退款
            "customerId":this.customerId,  // 业主ID
            "isDelFlag":"0", // 迁出和未迁出页面  1 迁出
            "projectId": this.projectId,
      }
        this.$http.post(this.$requestUrl.POST_CASHPLEDGE_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            // this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          // this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    NodeData(data){
        // console.log(data,"data")
        this.mangroupId = data.value
        this.mangrouplab = data.label
        this.ShareList()
    },
    Inquire(){

    },

    ChargeItem(){
        this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
            let arr = []
            for(let val of res.data.data){
                if(val.feeCategory == "01"){
                    let obj = {
                        "value":val.feeCode,
                        "label":val.feeName,
                    }
                    arr.push(obj)
                }
                this.ChargeItemList = arr
            }
        })
    }

  },
  mounted() {
    // this.ChargeItem()
    // this.ShareList()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.PageTabs{
  width: 100%;
  margin-bottom: 20px;
  .el-tabs__nav-scroll{
    border:none
  }
}
.el-tabs__content{
  display: none;
}
</style>